module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"openreporting":"Open reports"},"fi":{"openreporting":"Avaa raportit"},"sv":{"openreporting":"Öppna rapporterna"},"de":{"openreporting":"Berichte öffnen"},"ko":{"openreporting":"결과보고서 보기"}}')
  delete Component.options._Ctor
}
